// extracted by mini-css-extract-plugin
export default {"container":"_styles_container__-wHn-","pagination_wrap":"_styles_pagination_wrap__OmQIf"};